import React from 'react'
import { Formik } from 'formik'
import { Grid } from '@mui/material'

import ErrorComponent from '../../../components/ui-widgets/ErrorComponent'
import { type PortfolioSettlementDto } from '../../../../api-schema-types/asset-holdings/AdminPortfolioSettlementDomainDtos'
import ViewSettlementSummary from './ViewSettlementSummary'

export interface EditSettlementFormProps {
  settlement: PortfolioSettlementDto
}

const EditSettlementForm: React.FC<EditSettlementFormProps> = ({ settlement }: EditSettlementFormProps) => {
  // const dispatch = useAppDispatch()

  // ================================================================================================================
  //  FORM SETUP
  // ================================================================================================================

  const updateSettlementOnSubmit = async (values: PortfolioSettlementDto): Promise<void> => {
    // const updateProject = { ...values }
    //
    // await apiUpdateProjectTrigger({ ...updateProject })
    // dispatch(setOverrideLockedFields(false))
  }

  // ================================================================================================================
  //  UI Handlers
  // ================================================================================================================

  // const handleTabSelected = (event: React.ChangeEvent<unknown>, newValue: number): void => {
  //   dispatch(setSolarPlantTabIndex(newValue))
  // }

  // ================================================================================================================
  //  FORM MUTATION + RESULT
  // ================================================================================================================

  // const [apiUpdateProjectTrigger, updateResult] = useUpdateProjectMutation()

  // useEffect(() => {
  //   if (updateResult.isSuccess) {
  //     dispatch(setNotification({ open: true, severity: 'success', message: 'Project updated successfully' }))
  //   }
  //
  //   if (updateResult.isError) {
  //     dispatch(setNotification({
  //       open: true,
  //       severity: 'error',
  //       message: RtkQueryHelper.mapResponseError(updateResult.error)
  //     }))
  //   }
  // }, [updateResult.isSuccess, updateResult.isError])

  return (
    <>

      <Formik
        initialValues={settlement}
        // validationSchema={validateAssetProjectUpdateDto}
        onSubmit={async (values, actions) => {
          await updateSettlementOnSubmit(values)
        }}
      >
        {formikProps => (

          <form
            autoComplete={'off'}
            autoCorrect={'off'}
            onSubmit={formikProps.handleSubmit}
          >

            {!formikProps.isValid && (
              <Grid item md={12} sx={{ mt: 3 }}>
                <ErrorComponent title={'Form validation error'} message={JSON.stringify(formikProps.errors)}/>
              </Grid>
            )}
            <Grid item md={12} sx={{ mt: 3 }}>
              <ViewSettlementSummary settlement={settlement} />
            </Grid>
          </form>

        )}
      </Formik>

    </>
  )
}

export default EditSettlementForm
